import * as yup from 'yup';
var Validation = /** @class */ (function () {
    function Validation() {
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: yup.object({
                legalBusinessName: yup.string().required("Field is required").min(3, "Min 3 chars"),
                incorporationNr: yup.string().required("Field is required").min(3, "Min 3 chars"),
                email: yup.string().email().required('Field is required').min(3, "Min 3 chars"),
                vatId: yup.string().required("Field is required").min(3, "Min 3 chars"),
                skype: yup.string().optional(),
                businessPhone: yup.string().required("Field is required").min(3, "Min 3 chars"),
                customerServicePhone: yup.string().required("Field is required").min(3, "Min 3 chars"),
                country: yup.string().required("Field is required").min(3, "Min 3 chars"),
                dateEstablished: yup.date().max(new Date(), "Date established can't be today date").required("Field is required").typeError("Invalid Date!").nullable(),
                regStreetAddress: yup.string().required("Field is required").min(3, "Min 3 chars"),
                regCity: yup.string().required("Field is required").min(3, "Min 3 chars"),
                regCountry: yup.string().required("Field is required").min(3, "Min 3 chars"),
                regPostCode: yup.string().required("Field is required").min(3, "Min 3 chars"),
                mailStreetAddress: yup.string().required("Field is required").min(3, "Min 3 chars"),
                mailCity: yup.string().required("Field is required").min(3, "Min 3 chars"),
                mailCountry: yup.string().required("Field is required").min(3, "Min 3 chars"),
                mailPostCode: yup.string().required("Field is required").min(3, "Min 3 chars"),
                typeOfBusiness: yup.string().required("Company type is required").min(3, "Min 3 chars"),
                operatingFrom: yup.array().min(1, "Field is required").required("Field is required"),
                departments: yup.string().required("Field is required").min(3, "Min 3 chars"),
                numberOfEmployees: yup.number().required("Field is required").min(1),
                operationalStreetAddress: yup.string().required("Field is required").min(3, "Min 3 chars"),
                operationalStreetCity: yup.string().required("Field is required").min(3, "Min 3 chars"),
                operationalStreetCountry: yup.string().required("Field is required").min(3, "Min 3 chars"),
                operationalStreetPostalCode: yup.string().required("Field is required").min(3, "Min 3 chars"),
            })
        });
        Object.defineProperty(this, "initialTouch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                legalBusinessName: true,
                incorporationNr: true,
                email: true,
                vatId: true,
                skype: true,
                businessPhone: true,
                customerServicePhone: true,
                country: true,
                dateEstablished: true,
                regStreetAddress: true,
                regCity: true,
                regCountry: true,
                regPostCode: true,
                mailStreetAddress: true,
                mailCity: true,
                mailCountry: true,
                mailPostCode: true,
                typeOfBusiness: true,
                operatingFrom: true,
                departments: true,
                numberOfEmployees: true,
                operationalStreetAddress: true,
                operationalStreetCity: true,
                operationalStreetCountry: true,
                operationalStreetPostalCode: true,
            }
        });
    }
    return Validation;
}());
export { Validation };
